<template>
  <section
    class="section section-shaped section-lg my-0"
    style="padding-top:100px;"
  >
    <!-- <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
    </div> -->
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-7">
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-5"
            body-classes=""
            class="border-0"
          >
            <template>
              <div class="text-center text-muted mb-4">
                <div class="container" style="margin-top:50px">
                  <div class="row">
                    <div class="col-2">
                      <img
                        class="logo"
                        src="/img/logo_big.png"
                        alt="Judiciary Logo"
                      />
                    </div>
                    <div class="col-10">
                      <div style="margin-top:25px">                    
                        <h3>{{ vue_app_title }}</h3>
                        <h4>{{ vue_app_subtitle }}&nbsp;</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <form role="form">
                <base-input
                  alternative
                  class="mb-3"
                  placeholder="Login ID"
                  addon-left-icon="ni ni-circle-08"
                  v-model="username"
                >
                </base-input>
                <base-input
                  alternative
                  type="password"
                  placeholder="Password"
                  addon-left-icon="ni ni-lock-circle-open"
                  v-model="password"
                  v-on:keyup.enter="signIn"
                >
                </base-input>

                <div class="text-center">
                  <base-button type="primary" class="my-4" @click="signIn()"
                    >Sign In</base-button
                  >
                </div>
              </form>
            </template>
            <div style="float:right;">
              <p class="text-muted">{{ version }}</p>
            </div>
          </card>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
// @ is an alias to /src

import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "Home",
  data() {
    return {
      version: process.env.VUE_APP_WEBSITE_VERSION,
      vue_app_title: process.env.VUE_APP_TITLE,
      vue_app_subtitle: process.env.VUE_APP_SUBTITLE,
      username: "",
      password: "",
    };
  },
  methods: {
    get_cases(username, name) {
      axios
        .post(process.env.VUE_APP_WEB_HOST + "/case/get_cases", {})
        .then((res) => {
          if (res.data.cases.length > 1) {
            this.$router.push({
              name: "SelectCase",
              params: {
                username: username,
                name: name,
              },
            });
          } else {
            this.$router.push({
              name: "InputInfo",
              params: {
                username: username,
                case_id: res.data.cases[0].case_id,
                case_description: res.data.cases[0].case_description,
                name: name,
              },
            });
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error);
        });
    },
    signIn() {
      axios
        .post(process.env.VUE_APP_WEB_HOST + "/auth/login", {
          username: this.username,
          password: this.password,
        })
        .then((res) => {
          this.get_cases(res.data.username, res.data.name);
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error);
          if (error.response) {
            if (error.response.status == 403) {
              alert("Fail to login. \n Incorrect username or password.");
            } else {
              alert("Unexpected Server Error.");
            }
          } else if (error.request) {
            alert("Fail to connect to the server.");
          } else {
            alert("Unexpected Error.");
          }
        });
    },
  },
  components: {},
};
</script>

<style>
section {
  overflow-y: auto;
}
.logo {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: 120px;
  margin-bottom: 20px;
}
</style>
